///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../../../common/security.keys.ts"/>
///<reference path="../collections/report-distributors.collection.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ReportDistributorDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected distributors: ReportDistributorsCollection;

        public allSelectedLabel: string;
        public totalSelectedMessage: string;
        public title: string;

        get collection(): SmartMoverCollectionBase<any> {
            return this.distributors;
        }

        constructor(model: Dictionary<any>, properties: string[], options) {
            super(model, properties, options.criteria);

            this.title = 'LABEL_DISTRIBUTOR';
            this.allSelectedLabel = 'LABEL_ALL_DISTRIBUTORS';
            this.totalSelectedMessage = 'LABEL_TOTAL_DISTRIBUTORS_SELECTED';

            this.filters = [new ActiveInactiveFilter({hideInactiveLabel: 'LABEL_HIDE_INACTIVE_DISTRIBUTORS'})];

            this.distributors = new ReportDistributorsCollection(this.model[properties[0]], [], {
                criteria: options.criteria,
                defaultValue: (options.defaultValue || {})[properties[1]],
                smartMoverHidden: () => this.smartMoverHidden
            });
            this.distributors.addFilters(...this.filters as IInteractiveFilter[])
        }

        onHideToggle(hidden: boolean): void {
            this.smartMoverHidden = hidden;

            if (!this.smartMoverHidden) {
                this.distributors.resetCollection(this.getSelectedIdsFromModelList());
            }
        }

        getSelectedIdsFromModelList(): string[] {
            var array = [];
            if (this.distributors != null && this.distributors.allModelsList != null) {
                this.distributors.allModelsList.forEach((model, index) => {
                    array.push(model.id);
                });
            }
            return array;
        }
    }
}
